import { getInstance } from '@/auth/authWrapper'
import cfg from '@root/config'
import { Connector } from '../../types/main'

export async function login(connector: Connector, credentials: { token: string; companyId: string }) {
    const auth = getInstance()
    const authToken = await auth.getTokenSilently()
    const url = `${cfg.apiEndpoint}/dikidi/login`
    const options = {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
            connector,
            credentials,
        }),
    }
    const res = await fetch(url, options)
    if (res.status === 200) {
        return true
    } else {
        return false
    }
}
